import { API } from "../../../api/api";
import { AuthAPIRoutes } from "./auth.apiRoutes";

const _login = credentials => {
    const { email, password } = credentials;
    return API.request({
        routeID: AuthAPIRoutes.LOGIN,
        headers: API.getHeaders(),
        parameters: {
            email: email,
            pw: password
        }
    });
};

const _signup = newUserInfo => {
    const { email, password, firstName, lastName } = newUserInfo;
    return API.request({
        routeID: AuthAPIRoutes.REGISTER,
        headers: API.getHeaders(),
        parameters: {
            email: email,
            password: password,
            first_name: firstName,
            last_name: lastName
        }
    });
};

const _recover = recoverEmail => {
    return API.request({
        routeID: AuthAPIRoutes.RECOVER,
        headers: API.getHeaders(),
        parameters: {
            email: recoverEmail
        }
    });
};

const _newPassword = newPasswordInfo => {
    const { email, code, password } = newPasswordInfo;

    return API.request({
        routeID: AuthAPIRoutes.NEW_PASSWORD,
        headers: API.getHeaders(),
        parameters: {
            email: email,
            code: code,
            password: password
        }
    });
};

const _changeUserStatus = user_id => {
    return API.request({
        routeID: AuthAPIRoutes.CHANGE_USER_STATUS,
        routeParameters: {
            user_id: user_id
        }
    });
};

const _getUsers = search_json => {
    let final_filter_array = [];
    let skip_records = 0;
    let total_users_by_page = 12;
    if (search_json) {
        if (search_json["current_page"] && search_json["total_users_by_page"]) {
            skip_records =
                (search_json["current_page"] - 1) *
                search_json["total_users_by_page"];
            total_users_by_page = search_json["total_users_by_page"];
        }
        if (search_json["user_status"]) {
            final_filter_array.push(
                `account_status_id eq ${search_json["user_status"]}`
            );
        }
        if (
            search_json["roles"] &&
            search_json["roles"]["role_ids_array"].length &&
            search_json["roles"]["role_comparison_operator"]
        ) {
            final_filter_array.push(
                `user_role.role_id ${search_json["roles"]["role_comparison_operator"]} (${search_json["roles"]["role_ids_array"]
                    .map(c => c)
                    .join(",")},)`
            );
        }
    }
    return API.request({
        routeID: AuthAPIRoutes.GET_USERS,
        odataParameters: {
            skip: skip_records,
            top: total_users_by_page,
            search: search_json["search_term"],
            filter: final_filter_array.join(" and "),
            orderby: "first_name, last_name",
            groupby: "id"
        }
    });
};

const _getUsersPrivileges = () => {
    return API.request({
        routeID: AuthAPIRoutes.GET_USERS_PRIVILEGES,
        odataParameters: {
            skip: 0,
            top: 1000000
            //filter: 'permission_spec__domains__route__type eq "list"',
        }
    });
};

const _createUser = user_info => {
    return API.request({
        routeID: AuthAPIRoutes.CREATE_USER,
        parameters: user_info
    });
};

const _editUser = (user_id, user_info) => {
    return API.request({
        routeID: AuthAPIRoutes.EDIT_USER,
        routeParameters: {
            user_id: user_id
        },
        parameters: user_info
    });
};

const _getRoles = search_json => {
    const { current_page, total_roles_by_page } = search_json;
    return API.request({
        routeID: AuthAPIRoutes.GET_ROLES,
        odataParameters: {
            skip: (current_page - 1) * total_roles_by_page,
            top: total_roles_by_page,
            search: "",
            //filter: 'permission_spec__domains__route__type eq "list"',
            orderby: "name"
        }
    });
};

const _createRole = role_info => {
    return API.request({
        routeID: AuthAPIRoutes.CREATE_ROLE,
        parameters: role_info
    });
};

const _deleteRole = role_id => {
    return API.request({
        routeID: AuthAPIRoutes.DELETE_ROLE,
        routeParameters: {
            spec_id: role_id
        }
    });
};

const _editRole = info => {
    const { role_id, role_info } = info;
    return API.request({
        routeID: AuthAPIRoutes.EDIT_ROLE,
        routeParameters: {
            spec_id: role_id
        },
        parameters: role_info
    });
};

const _getSubsidiaries = () => {
    const odataParameters = {
        skip: 0,
        top: 10000
    };
    return API.request({
        routeID: AuthAPIRoutes.GET_SUBSIDIARIES,
        odataParameters
    });
};


const _getResourceEntity = () => {
    return API.request({
        routeID: AuthAPIRoutes.GET_RESOURCE_ENTITY
    });
};


export const authAPI = {
    //getRoutes: API.getRoutes,
    login: _login,
    signup: _signup,
    recover: _recover,
    newPassword: _newPassword,
    changeUserStatus: _changeUserStatus,
    getUsers: _getUsers,
    getUsersPrivileges: _getUsersPrivileges,
    createUser: _createUser,
    editUser: _editUser,
    getRoles: _getRoles,
    createRole: _createRole,
    deleteRole: _deleteRole,
    editRole: _editRole,
    getSubsidiaries: _getSubsidiaries,
    getResourceEntity: _getResourceEntity,
};
